import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_refresh-nocolor",
  "use": "svg_refresh-nocolor-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"svg_refresh-nocolor\"><path d=\"M.667 2.857v4h4M15.333 13.523v-4h-4\" stroke=\"currentColor\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M13.66 6.19a6 6 0 0 0-9.9-2.24L.667 6.857m14.667 2.666L12.24 12.43a6 6 0 0 1-9.9-2.24\" stroke=\"currentColor\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol